import LessonPlanSection from './LessonPlanSection';

export default LessonPlanSection;
